var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 113,
    viewBox: "0 0 134 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 36.5026L28 29V88L0 95.5026V36.5026Z",
    fill: "#2574DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5533 68.3154L22.0936 57.7751C22.2584 57.6104 22.2584 57.3432 22.0936 57.1785L21.0993 56.1841C20.9345 56.0194 20.6674 56.0194 20.5026 56.1841L11.255 65.4317L7.85714 62.0338C7.69238 61.8691 7.42527 61.8691 7.26048 62.0338L6.26615 63.0281C6.10139 63.1929 6.10139 63.46 6.26615 63.6248L10.9567 68.3154C11.1214 68.4801 11.3885 68.4801 11.5533 68.3154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 53.7513L54 50V109L40 112.751V53.7513Z",
    fill: "#D09CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3932 40.7109L47.1799 36.9235L50.9669 40.7105C51.1859 40.9295 51.5414 40.9295 51.7607 40.7105L52.6407 39.8306C52.8597 39.6115 52.8597 39.2561 52.6407 39.0367L48.8533 35.2501L52.6404 31.4631C52.8594 31.244 52.8594 30.8886 52.6404 30.6692L51.7604 29.7893C51.5414 29.5702 51.1859 29.5702 50.9666 29.7893L47.1799 33.5766L43.3929 29.7896C43.1738 29.5706 42.8184 29.5706 42.5991 29.7896L41.7194 30.6692C41.5004 30.8882 41.5004 31.2437 41.7194 31.4631L45.5065 35.2501L41.7194 39.0371C41.5004 39.2561 41.5004 39.6115 41.7194 39.8309L42.5994 40.7109C42.8184 40.9299 43.1738 40.9299 43.3932 40.7109Z",
    fill: "#FFA100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 18.5026L94 11V70L66 77.5026V18.5026Z",
    fill: "#241F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5533 50.3154L88.0936 39.7751C88.2584 39.6104 88.2584 39.3432 88.0936 39.1785L87.0993 38.1841C86.9345 38.0194 86.6674 38.0194 86.5026 38.1841L77.255 47.4317L73.8571 44.0338C73.6924 43.8691 73.4253 43.8691 73.2605 44.0338L72.2661 45.0281C72.1014 45.1929 72.1014 45.46 72.2661 45.6248L76.9567 50.3154C77.1214 50.4801 77.3885 50.4801 77.5533 50.3154Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 7.50258L134 0V59L106 66.5026V7.50258Z",
    fill: "#FFA100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.553 39.3154L128.094 28.7751C128.258 28.6104 128.258 28.3432 128.094 28.1785L127.099 27.1841C126.935 27.0194 126.667 27.0194 126.503 27.1841L117.255 36.4317L113.857 33.0338C113.692 32.8691 113.425 32.8691 113.26 33.0338L112.266 34.0281C112.101 34.1929 112.101 34.46 112.266 34.6248L116.957 39.3154C117.121 39.4801 117.389 39.4801 117.553 39.3154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestLogo);
export default __webpack_public_path__ + "static/media/invest-logo.d46a6f5b25d5282e3b885ea0bd2845ff.svg";
export { ForwardRef as ReactComponent };